export interface IMinimizedVideoMaterialProps {
    onDragEnd?: () => void;
    disabled?: boolean;
}

export const MIN_VIDEO_MATERIAL_DRAG_TYPE = 'MIN_VIDEO_MATERIAL_DRAG_TYPE';
